module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-1200x2-85e14b4761ec299426b53bd11dc0b97e.jpg";